<template>
	<p-card class="guideline-job-form">
		<h3 class="tw-mb-2">Agrega todos los puestos de TRABAJO DE  tu empresa</h3>
		<form class='job-form' @submit="addJob">
			<v-text-field
				label="Puesto de trabajo"
				solo
				hide-details
				class="input-text"
				v-model="jobName"
			></v-text-field>
			<v-btn class="custom-button" color="primary" fab type="submit" :disabled='disabledAddButton'>
				<v-icon>add</v-icon>
			</v-btn>
		</form>
		<v-layout row tw-mt-3>
			<v-flex xs12>
				<v-select
					label="Seleccione Área"
					class="select-core"
					hide-details
					clearable
					:menu-props="{ contentClass: 'type-select-content' }"
					height="37"
					outline
					single-line
					:items="groups"
					item-value="id"
					item-text="name"
					v-model="selectedAreaId"
					@change="$emit('area-filter-change', $event)"
				></v-select>
			</v-flex>
		</v-layout>
		<v-snackbar
			v-model="showMessage"
			:bottom="true"
		>
			{{ message }}
		</v-snackbar>
	</p-card>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import { any, propEq, isEmpty } from 'ramda';

const INPUT_MAX_LENGTH = '60';

export default {
	name: 'guideline-job-form',
	components: { PCard },
	props: ['jobList', 'maxJobsList', 'groups', 'areaFilter'],
	data() {
		return {
			jobName: '',
			showMessage: false,
			message: '',
			selectedAreaId: this.areaFilter || null,
		};
	},
	mounted() {
		const input = document.querySelector('.job-form input');
		input.setAttribute('maxLength', INPUT_MAX_LENGTH);
	},
	computed: {
		disabledAddButton() {
			return isEmpty(this.jobName) || this.jobList.length === this.maxJobsList;
		},
	},
	methods: {
		addJob(event) {
			event.preventDefault();
			if (this.itemExists(this.jobName)) {
				this.showMessageSnacker('Ya existe un puesto con ese nombre.');
				return;
			}
			this.$emit('jobAdded', this.jobName);
			this.jobName = '';
		},
		itemExists(jobName) {
			return any(propEq('name', jobName), this.jobList);
		},
		showMessageSnacker(message) {
			this.message = message;
			this.showMessage = true;
			setTimeout(() => { this.showMessage = false; }, 6000);
		},
	},
};
</script>

<style lang='scss' scoped>
.guideline-job-form {
	h3 {
		text-transform: uppercase;
		font-size: 12px;
		color: var(--app-color-primary);
	}
	.job-form {
		position: relative;
		.v-input {
			width: calc(100% - 50px);
		}
		.v-btn {
			position: absolute;
			top: 0;
			right: 0;
			width: 40px !important;
			border-radius: 8px !important;
			.v-icon {
				color: white !important;
				padding-top: 5px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-job-form.vue